export const iconFontAwesomeHolidaysMugHot = (
	<i className="fa-solid fa-mug-hot"></i>
);
